import { useState } from 'react';
import PropTypes from 'prop-types';
import ConfirmDialog from '../../dialogs/ConfirmDialog';
import Button from '../../buttons/Button';
import LoadingPanel from '../../LoadingPanel';
import withMeta from '../../utils/withMeta';
import * as requests from '../../utils/requests';
import { buildUrl } from '../../utils/helper';

const UpdateStoringSchema = ({ selected, showMsg, db, meta }) => {
  const [state, setState] = useState({
    isOpen: false,
    isLoading: false
  });

  const handleOpen = () => {
    setState((prevState) => ({ ...prevState, isOpen: true }));
  };

  const handleClose = () => {
    setState((prevState) => ({ ...prevState, isOpen: false }));
  };

  const handleConfirm = async () => {
    setState((prevState) => ({ ...prevState, isOpen: false, isLoading: true }));

    try {
      await requests.put(`/api/meta/schema/update-storing-schema`, {});
      showMsg('Akcia aktulizácie schém prebehla úspešne');
    } catch (error) {
      showMsg(error.message, 'error');
    }

    setState((prevState) => ({ ...prevState, isLoading: false }));
  };

  return (
    <>
      <ConfirmDialog
        isOpen={state.isOpen}
        onClose={handleClose}
        onConfirm={handleConfirm}
        text="Spustiť aktualizáciu schém ?"
        confirmText="Áno"
        cancelText="Nie"
      />
      <Button
        onClick={handleOpen}
        title="Aktualizácia schém"        
        imageUrl={buildUrl('assets/icons/toolbar/refresh.svg')}
      />
      <LoadingPanel isLoading={state.isLoading} />
    </>
  );
}

UpdateStoringSchema.propTypes = {
  selected: PropTypes.array.isRequired,
  showMsg: PropTypes.func.isRequired,
  db: PropTypes.string,
  meta: PropTypes.object
}

export default withMeta(UpdateStoringSchema);